module.exports = __webpack_public_path__ + "static/media/background.084a35eb.png";